import React from "react"
import UploadFiles from "../UploadFiles/UplaodFiles"
import "./PedigreeView.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { deleteFile } from "../../../../../../core/services/api"
import {
  faFileAlt, faTrash,
  faArrowDown
} from "@fortawesome/free-solid-svg-icons"
import Button from "../../../../../../components/Button"
import moment from "moment"
import fileUtils from "fileUtils"

function PedigreeView({
  docs,
  updateDocs,
  appointmentId,
  recordId,
  patient,
  type,
  uploadDocument,
  onDeleteFile,
  isReadOnly
}: any) {

  const urls = [...docs].map((each) => each?.blobUrl);

  //delete file
  const handleDeleteFile = (name: any, id: any) => {
    if (type === "BookAppointment") {
      console.log(docs, "CHECK")
      let temp = docs.filter((doc: any) => doc.name !== name)
      console.log(temp, "TEMP")
      uploadDocument(temp)
    } else if (type === "DocumentRMO") {
      deleteFile({
        patientId: patient.id,
        mocDocumentId: id,
      })
        .then((data: any) => {
          console.log(data)
          //updateDocs(data)
          onDeleteFile()
        })
        .catch((err: any) => {
          console.log(err)
        })
    }
  }

  function downloadFiles() {
    var delay = 1000;
    const urls = docs?.length > 0 ? docs : []
    async function download(index: any) {
      if (index >= urls.length) {
        return;
      }
      var link = document.createElement('a');
      const documentUrl: any = await fileUtils.getFileUrl(urls[index]?.blobUrl)
      link.href = documentUrl
      setTimeout(function () {
        link.click();
        link.remove();
        download(index + 1);
      }, delay);
      document.body.appendChild(link);
    }
    download(0);
  }

  return (
    <div className="pedigree-container">
      <UploadFiles
        docs={docs}
        updateDocs={updateDocs}
        appointmentId={appointmentId}
        recordId={recordId}
        patient={patient}
        type={type}
        uploadDocument={uploadDocument}
        isReadOnly={isReadOnly}
      />

      {
        docs?.length > 0 && (
          <div className="d-flex justify-content-end mt-3 cursor-pointer">
            <Button disabled={isReadOnly} text="Download All" id="download-all"
              onClick={(e: any) => downloadFiles()} />
          </div>
        )
      }

      <div className="pedigree-docs-container">
        {docs.length > 0 &&
          docs?.map((ele: any) => {
            const nameParts = ele?.name ? ele?.name?.split(':') : [];
            const [name, nameStr, datestr, timeStr] = nameParts
            // Formatting the date
            const formattedDate = ele?.createdAt ? moment(ele?.createdAt?.split('T')[0], 'YYYY-MM-DD').format('DD-MM-YYYY') : moment()?.format('DD-MM-YYYY');

            return (
              <div className="file-list">
                <span>
                  <FontAwesomeIcon
                    className="doc-icon"
                    size="4x"
                    icon={faFileAlt}
                  />
                </span>


                <div className="file-name">{name}:{nameStr}</div>
                <div>{formattedDate}</div>
                {
                  !isReadOnly && (
                    <a
                      // href={ele?.blobUrl}
                      // download={ele?.blobUrl}
                      onClick={() => fileUtils.downloadFile(ele)}
                    >
                      <FontAwesomeIcon
                        className="download-icon cursor-pointer"
                        icon={faArrowDown}
                      />
                    </a>
                  )
                }
                {type !== "pedigree" && (
                  !isReadOnly && (
                    <span style={{ height: "35px" }} >
                      <FontAwesomeIcon
                        className="delete-icon"
                        icon={faTrash}
                        onClick={() => handleDeleteFile(ele.name, ele.id)}
                      />
                    </span>
                  )
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default PedigreeView
